import { Component, OnInit, Signal, computed, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ProducersService } from '../producers.service';
import { CarouselComponent } from '../../../shared/carousel/carousel.component';
import { capitalizeWords, handleImageError } from '../../../shared/common/utils';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-producer-detail',
  imports: [RouterLink, CommonModule, CarouselComponent],
  templateUrl: './producer-detail.component.html',
  styleUrl: './producer-detail.component.scss'
})
export class ProducerDetailComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private producersService = inject(ProducersService);
  private meta = inject(Meta);
  private title = inject(Title);
  private sanitizer = inject(DomSanitizer)

  seoURL!: string;
  producerDetails: Signal<any> = computed(
    () => this.producersService.producerDetailsSignal() || null
  );
  loadingProducts: Signal<any> = computed(
    () => !!this.producersService.isLoadingProducts()
  );
  carouselProducerProducts: Signal<any | undefined> = computed(() =>
    this.setUpCarouselItems()
  );

  handleImageError = handleImageError;

  ngOnInit(): void {
    this.handleRouteChanges();
  }

  private setUpSEOTags(producer: string) {
    const { baseTitle, baseURL, type } = environment.config.seo;
    const url = `pages/producers/${producer}`
    const title = `${capitalizeWords(producer)} | ${baseTitle}`;

    // Page title
    this.title.setTitle(title);

    // Open Graph for social networks:
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ property: 'og:url', content: `${baseURL}${url}` });
    this.meta.addTag({ property: 'og:type', content: type });
  }

  private handleRouteChanges(): any {
    this.activatedRoute.params.subscribe((params) => {
      this.seoURL = `${params['producerUrl']}`;
      this.producersService.getProducerByUrl(this.seoURL);
      this.setUpSEOTags(this.seoURL);
    });
  }

  private setUpCarouselItems(): any[] {
    const items = this.producerDetails()?.products.filter((p: any) => !!p).map((product: any) => {
      product.image = product.img;
      product.name = product.name;
      if (typeof product?.price === 'number')
        product.price = product.price.toFixed(2);

      return {
        content: {
          productDetails: product,
          settings: { isCardInOrderPage: true },
        },
      };
    });
    return items;
  }

  sanitizeHtml(html: string): SafeHtml {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return this.sanitizer.bypassSecurityTrustHtml(doc.body.innerHTML);
  }
}
